import React, { useEffect, useState } from 'react';
import { Share, X } from 'lucide-react';

const isIOS = () =>
  /iphone|ipad|ipod/i.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

const isStandalone = () =>
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone === true;

const IOSInstallHint = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isIOS() && !isStandalone()) {
      const dismissed = localStorage.getItem('ios-install-hint-dismissed');
      if (!dismissed) {
        const timer = setTimeout(() => setVisible(true), 2500);
        return () => clearTimeout(timer);
      }
    }
  }, []);

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem('ios-install-hint-dismissed', '1');
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-[72px] left-4 right-4 z-[200] animate-in slide-in-from-bottom-4 duration-300"
      style={{ bottom: `calc(72px + env(safe-area-inset-bottom))` }}
    >
      <div className="bg-popover border border-border rounded-2xl shadow-2xl p-4 flex items-start gap-3">
        <div className="bg-primary/10 rounded-xl p-2 shrink-0 mt-0.5">
          <Share className="h-5 w-5 text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-foreground leading-snug">
            App zum Homescreen hinzufügen
          </p>
          <p className="text-xs text-muted-foreground mt-1 leading-relaxed">
            Tippe auf{' '}
            <span className="inline-flex items-center gap-0.5 font-medium text-foreground">
              <Share className="h-3 w-3 inline" /> Teilen
            </span>{' '}
            unten und wähle dann{' '}
            <strong className="text-foreground">„Zum Home-Bildschirm"</strong>.
          </p>
        </div>
        <button
          onClick={dismiss}
          className="shrink-0 p-1 rounded-full hover:bg-muted transition-colors text-muted-foreground"
          aria-label="Schließen"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
      {/* Arrow pointing down */}
      <div className="absolute bottom-[-8px] left-1/2 -translate-x-1/2 w-4 h-4 bg-popover border-r border-b border-border rotate-45 shadow-sm" />
    </div>
  );
};

export default IOSInstallHint;
